/* eslint-disable no-nested-ternary */
import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import { Grid } from '@mui/material';
import StarRateIcon from '@mui/icons-material/StarRate';
import { formatNumberUsingRegex } from '../../../../pricing-simulator';
import {
  Header,
  InputType,
  TableComponent
} from '../../../../pricing-simulator/types/generic-table.model';
import DisplayCell from '../../../../pricing-simulator/components/table-columns/display-cell';

export default function getColumnForTextType(
  columnData: Header,
  maxVal?: number,
  isDisplayHeader?: boolean,
  componentType?: any,
  footerRows: any[] = []
) {
  // handler to get cell value for first column of load save scenario table for fav row
  const getCellValue = (cellObj, headerName) => {
    if (
      componentType === TableComponent.MULTIYEARESTIMATE &&
      headerName.parent.parent_field === 'year' &&
      cellObj.getValue().toUpperCase() === 'NAN'
    ) {
      return null;
    }
    // adding fav icon only for the first column, where column is of scenario name
    if (
      componentType === 'SCENARIOMANAGER' &&
      window.location.pathname.includes('planner-simulator')
    ) {
      if (headerName.parent.alias === 'Scenario Name') {
        return (
          <div className='fav-row-div'>
            <div className='fav-row-icon'>
              {cellObj.row.original.is_favourite && (
                <StarRateIcon sx={{ fontSize: '18px', color: '#0000a0' }} />
              )}
            </div>

            {cellObj.getValue()}
          </div>
        );
      }
    }
    return (
      <div>
        <div className='fav-row-icon'></div>
        {cellObj.getValue()}
      </div>
    );
  };

  return {
    accessorKey: columnData.parent.parent_field,
    id:
      columnData.parent.parent_field !== ''
        ? columnData.parent.parent_field
        : columnData.parent.order,

    // showing "..." in case of more than 7 values in the string
    cell: (info) =>
      columnData &&
      columnData.parent.number_format &&
      typeof info.getValue() === 'number'
        ? formatNumberUsingRegex(columnData, info.getValue())
        : typeof info.getValue() === 'string'
        ? info.getValue()?.split(',').length > 7
          ? info.getValue().split(',').slice(0, 6).join(', ') + ' ...'
          : // getting cell value to show fav icon
            getCellValue(info, columnData)
        : info.getValue(),
    meta: {
      className:
        (columnData.parent.order === maxVal || maxVal === undefined) &&
        columnData.parent.field_format === InputType.TEXT
          ? 'last text-column'
          : (columnData.parent.order === maxVal || maxVal === undefined) &&
            columnData.parent.field_format !== InputType.TEXT
          ? 'last'
          : columnData.parent.field_format === InputType.TEXT
          ? 'text-column'
          : ''
    },
    header: () => (
      <Grid container alignItems='center' flexDirection='column'>
        <Grid
          item
          xs='auto'
          container
          alignItems='center'
          className='change-text'
        >
          {isDisplayHeader ? (
            <Grid item sx={{ cursor: 'pointer' }}>
              {columnData.parent.alias}
              {getHeaderName(columnData)}
            </Grid>
          ) : null}
        </Grid>
      </Grid>
    ),
    footer: () => {
      const data =
        footerRows &&
        footerRows?.length &&
        footerRows?.map((val) => {
          if (TableComponent.PPGLEVELIMPACT == componentType) {
            return (
              <div
                style={{ height: '30px' }}
                key={`footer_${columnData?.parent?.parent_field}`}
              >
                <DisplayCell
                  colorCode={columnData.parent.is_cf_enable}
                  columnMetadata={columnData}
                  value={
                    val?.parent?.data[
                      columnData?.parent?.parent_field
                    ] as number
                  }
                />
              </div>
            );
          }
        });
      return data || null;
    }
  };
}
